
import Rule from './Rule';
import should from 'should';
import type { ActionType, ActionData } from './Action';

export interface RuleData {
    rule: string,
    type: string
}

export default class ActionableRule extends Rule {
    evaluate() {
        try {
            var ruleFn = new Function("should", this.ruleData.rule + ";return this.pass();");
            const result = ruleFn.call(this, should);
            return result
        } catch (e) {
            return null;
        }
    }

    accept() {
        return null;
    }

    reject() {
        return null;
    }

    pass() {
        return null;
    }

    _addElementToComposition(reference: string, quantity: number) {
        return this.execute('add', { reference, quantity });
    }

    execute(actionType: ActionType, actionData: ActionData) {
        return { actionType, data: { reference: actionData.reference, quantity: actionData.quantity } };
    }
}

